import React, { useState } from 'react';
import { ClockIcon, MapPinIcon } from 'lucide-react';
import { cleanoutJobs } from '../data/content';
export function BeforeAfter() {
  const [activeId, setActiveId] = useState(cleanoutJobs[0].id);
  const job = cleanoutJobs.find(j => j.id === activeId) ?? cleanoutJobs[0];
  return <section id="before-after" className="w-full bg-white py-16 lg:py-24" data-id="element-21" data-mp="3sgtnhlitk981">
      <div className="mx-auto max-w-6xl px-5" data-id="element-22" data-mp="3epyco3orfi1t">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-23" data-mp="3ep6fiofilc9f">
          <div className="max-w-xl" data-id="element-24" data-mp="3jhq4ehjnjttj">
            <h2 className="font-display text-3xl uppercase leading-tight text-forest-800 sm:text-4xl" data-id="element-25" data-mp="3jirgmpcemmcu">
              Before &amp; after: real North County cleanouts
            </h2>
            <p className="mt-3 text-lg text-ink-700" data-id="element-26" data-mp="39ren7tayjo4p">
              Same driveway, same day. This is what your space looks like after the trailer pulls
              out.
            </p>
          </div>

          <div className="flex shrink-0 rounded-md bg-forest-50 p-1" role="tablist" aria-label="Choose a cleanout job" data-id="element-27" data-mp="30pnh4nci9fab">
            {cleanoutJobs.map(option => {
            const selected = option.id === job.id;
            return <button key={option.id} type="button" role="tab" aria-selected={selected} onClick={() => setActiveId(option.id)} className={`rounded px-4 py-2.5 font-display text-sm uppercase tracking-wide transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-forest-800 ${selected ? 'bg-forest-800 text-white' : 'text-forest-800 hover:bg-forest-100'}`} data-id="element-28" data-mp="t5b9zvgy40b9">
                  {option.label}
                </button>;
          })}
          </div>
        </div>

        {job.combinedImage ? <figure className="mt-8 overflow-hidden rounded-lg border border-forest-100" data-id="element-29" data-mp="jdfb4i71c65z">
            <img src={job.combinedImage} alt={`${job.label} in ${job.location} — before and after Javier's Junk Removal`} className="w-full object-cover" data-id="element-30" data-mp="3rsz0h64l54fr" />
          </figure> : <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-31" data-mp="3mtclar575e4b">
            {[{
          tag: 'Before',
          image: job.beforeImage,
          tone: 'bg-ink-900 text-white'
        }, {
          tag: 'After',
          image: job.afterImage,
          tone: 'bg-ember-500 text-ink-900'
        }].map(({
          tag,
          image,
          tone
        }) => <figure key={tag} className="relative overflow-hidden rounded-lg border border-forest-100" data-id="element-32" data-mp="24inqnuke9zmr">
                <img src={image} alt={`${job.label} in ${job.location} — ${tag.toLowerCase()} Javier's Junk Removal`} className="h-64 w-full object-cover sm:h-80" data-id="element-33" data-mp="17sn7qc6piddd" />
                <figcaption className={`absolute left-4 top-4 rounded px-3 py-1 font-display text-sm uppercase tracking-[0.18em] ${tone}`} data-id="element-34" data-mp="1cst05uksw3wi">
                  {tag}
                </figcaption>
              </figure>)}
          </div>}

        <div className="mt-6 flex flex-col gap-4 rounded-lg bg-forest-50 p-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-35" data-mp="2s88fuv755t4h">
          <p className="max-w-2xl text-base text-ink-700" data-id="element-36" data-mp="2x5i8ejptukwj">{job.summary}</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-37" data-mp="37b00hkw26ujn">
            <span className="flex items-center gap-2 text-sm font-semibold text-forest-800" data-id="element-38" data-mp="37cku98aju9gg">
              <MapPinIcon className="h-4 w-4 text-ember-600" aria-hidden="true" data-id="element-39" data-mp="32dqcm9obiqxx" />
              {job.location}
            </span>
            <span className="flex items-center gap-2 text-sm font-semibold text-forest-800" data-id="element-40" data-mp="2tjlk7ltjd7ga">
              <ClockIcon className="h-4 w-4 text-ember-600" aria-hidden="true" data-id="element-41" data-mp="2ojz5t91z1l5w" />
              {job.turnaround}
            </span>
          </div>
        </div>
      </div>
    </section>;
}